import Vue from 'vue'

export const EventBus = new Vue()

const stickyEvents = new Map()

EventBus.$emitSticky = function (event, ...args) {
  stickyEvents.set(event, args)
  this.$emit(event, ...args)
}

EventBus.$onSticky = function (event, handler) {
  this.$on(event, handler)
  if (stickyEvents.has(event)) {
    handler(...stickyEvents.get(event))
  }
}

EventBus.$clearSticky = function (event) {
  stickyEvents.delete(event)
}
